// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#222","pageWidth":"1200","pageWidthPx":"1200px","label":"styles-module--label--3BaNR"};